import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";
import { Icon } from "@/components/icon/icon";
import { ICON_KEYS } from "@/icons/icon-registry";
import { BATTERY_LEVEL } from "@/services/device-attributes/attributes/battery/definitions";

/**
 * The icons for the battery levels
 */
export const batteryLevelIconKeys = {
    [BATTERY_LEVEL.LOW]: ICON_KEYS.BATTERY_LOW,
    [BATTERY_LEVEL.OK]: ICON_KEYS.BATTERY_OK,
    [BATTERY_LEVEL.GOOD]: ICON_KEYS.BATTERY_GOOD,
    [BATTERY_LEVEL.FULL]: ICON_KEYS.BATTERY_FULL,
    [BATTERY_LEVEL.UNKNOWN]: ICON_KEYS.BATTERY_UNKNOWN,
    [BATTERY_LEVEL.ERROR]: ICON_KEYS.BATTERY_ERROR,
};

/**
 * The translation key prefix for the battery levels
 */
export const BATTERY_LEVEL_TRANSLATION_NAMESPACE = NAMESPACES.ICONS;
export const BATTERY_LEVEL_TRANSLATION_KEY_PREFIX = "battery-status";

export const batteryLevelTooltipTranslationKeys = {
    [BATTERY_LEVEL.LOW]: "tooltip.battery-low",
    [BATTERY_LEVEL.OK]: "tooltip.battery-ok",
    [BATTERY_LEVEL.GOOD]: "tooltip.battery-good",
    [BATTERY_LEVEL.FULL]: "tooltip.battery-full",
    [BATTERY_LEVEL.UNKNOWN]: "tooltip.battery-unknown",
    [BATTERY_LEVEL.ERROR]: "tooltip.battery-error",
};

export const batteryLevelLabelTranslationKeys = {
    [BATTERY_LEVEL.LOW]: "label.battery-low",
    [BATTERY_LEVEL.OK]: "label.battery-ok",
    [BATTERY_LEVEL.GOOD]: "label.battery-good",
    [BATTERY_LEVEL.FULL]: "label.battery-full",
    [BATTERY_LEVEL.UNKNOWN]: "label.battery-unknown",
    [BATTERY_LEVEL.ERROR]: "label.battery-error",
};

interface BatteryStatusIconProps {
    includeLabel?: boolean;
    includeTooltip?: boolean;
    batteryLevel: BATTERY_LEVEL;
}
export function BatteryStatusIcon({
    includeLabel = true,
    includeTooltip = true,
    batteryLevel,
}: BatteryStatusIconProps) {
    const { t } = useTranslation(NAMESPACES.ICONS, { keyPrefix: BATTERY_LEVEL_TRANSLATION_KEY_PREFIX });

    const tooltip = t(batteryLevelTooltipTranslationKeys[batteryLevel]);
    const label = t(batteryLevelLabelTranslationKeys[batteryLevel]);

    return (
        <Icon
            icon={batteryLevelIconKeys[batteryLevel]}
            label={includeLabel ? label : undefined}
            tooltip={includeTooltip ? tooltip : undefined}
        />
    );
}
